// RJ Seller Visibility Workflow — shared confirmation copy.
//
// Verbatim from Ashley (Raymond James) — do NOT paraphrase. The reversibility
// sentence on the opt-in string was appended per Ashley/Rob's 2026-07-20
// review: legal sign-off was waived on condition that we surface that the
// seller can turn visibility off at any time.
//
// This module exists so Succession Settings and the LaunchPad quickstart card
// cannot drift apart. Both surfaces import from here; neither defines its own
// copy. If RJ revises the wording, it changes in exactly one place.
//
// See docs/plans/2026-07-17-001-feat-rj-seller-visibility-workflow-plan.md

export const RJ_VISIBILITY_OPT_IN_COPY =
  "You are now selecting to be visible to buyers. This will mean that buyers will be able to view your profile on the platform via the search feature, you could be contacted by buyers wanting to connect, and there could be instances where a buyer recognizes you by your location and reaches out to you outside of the platform. You can turn this off at any time from your settings.";

export const RJ_VISIBILITY_OPT_OFF_COPY =
  "You are now selecting to turn off visibility, which will mean that your profile will go back to hidden and is not searchable.";

export const copyForIntent = (intent) =>
  intent === 'enable' ? RJ_VISIBILITY_OPT_IN_COPY : RJ_VISIBILITY_OPT_OFF_COPY;
